import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    untitled: 'Без названия',
    author: 'Автор',
    cover: 'Обложка',
  },
  en: {
    untitled: 'Untitled',
    author: 'Author',
    cover: 'Cover',
  },
})
